import React from "react";
import { CheckIcon } from "lucide-react";
import { heroImage, offerList } from "../data/content";
import { CheckoutButton } from "./CheckoutButton";
export function Pricing() {
  return <section id="offre" className="scroll-mt-12 border-t border-line bg-panel px-4 py-14 sm:px-5 sm:py-20" data-id="element-113" data-mp="2oj8s3pcc6fhb">
      <div className="mx-auto max-w-5xl rounded-3xl border-2 border-gold bg-ink p-5 sm:p-10" data-id="element-114" data-mp="2jjcnbnvtek0p">
        <div className="text-center" data-id="element-115" data-mp="1vticfbv235j3">
          <p className="text-xs font-bold tracking-widest text-gold sm:text-sm" data-id="element-116" data-mp="1vujxm95sd8ej">LE PACK COMPLET</p>
          <h2 className="mt-2 font-display text-3xl uppercase leading-tight text-cream sm:text-5xl" data-id="element-117" data-mp="1ru15sf3w82cc">
            Le Maître de la Guitare™ <span className="block text-gold sm:inline" data-id="element-118" data-mp="25pv5c7is1fcs">— 2 livres + 5 bonus</span>
          </h2>
        </div>

        <div className="mt-8 grid items-center gap-8 lg:grid-cols-2 lg:gap-10" data-id="element-119" data-mp="3h7ecuc3e44h5">
          <img src={heroImage} alt="Les 2 livres et les 5 bonus du pack" loading="lazy" className="mx-auto w-full max-w-md rounded-2xl border border-line lg:max-w-none" data-id="element-120" data-mp="3h9haniasb1wf" />
          <ul className="space-y-3" data-id="element-121" data-mp="4svxpvc9xcvi">
            {offerList.map(item => <li key={item} className="flex gap-3 text-sm text-cream sm:text-base" data-id="element-122" data-mp="4uyrmqgjrq5i">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden data-id="element-123" data-mp="9q5rfn6p4ap5" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-10 max-w-xl text-center" data-id="element-124" data-mp="3daa43mhz5j43">
          <p className="text-sm font-bold tracking-widest text-mute" data-id="element-125" data-mp="3i7sfdjjgsaf9">LE PACK COMPLET POUR</p>
          <p className="mt-1 font-display text-7xl text-gold sm:text-8xl" data-id="element-126" data-mp="3n7evq1ula6sa">27 $ US</p>
          <p className="mt-2 text-sm text-cream" data-id="element-127" data-mp="3n5ak0xqg83hg">≈ 23 € · Paiement unique · Aucun abonnement</p>
          <CheckoutButton className="mt-7 w-full" data-id="element-128" data-mp="3rzojbb88eure" />
          <p className="mt-3 text-xs text-mute sm:text-sm" data-id="element-129" data-mp="2uhekll9hvxgz">PDF envoyés par e-mail · Paiement sécurisé · Carte bancaire</p>
        </div>
      </div>
    </section>;
}